import { ModalityType } from '../../../generated-interfaces/graphql';
import { ICartItemsState } from '../../../reducers/cartSlice.props';

/**
 * HITL-1611 — the agent's own cart, built while the AI still drives the order.
 *
 * Exactly `ICartItemsState`: items, their quantities, their collapse states, a
 * sequence id and the modality. Deliberately NOT a second `ICartState` — the
 * draft never holds loyalties, coupons, a POS cart or loyalty requests, because
 * it never sends an order. Those live on `cartSlice` alone, which is what keeps
 * "the agent's cart" from quietly becoming a second thing that can reach the POS.
 */
export type IDraftCartState = ICartItemsState;

/**
 * A fresh draft, built per call. Returning a shared object would let two resets
 * hand out the same `cartItems` reference; the cost of not sharing is nil.
 */
export const freshDraftCart = (): IDraftCartState => ({
  cartItems: {},
  cartItemsQuantity: {},
  cartItemCollapseStates: {},
  sequenceId: 1,
  modality: ModalityType.Dinein,
});

export const initialDraftCartState: IDraftCartState = freshDraftCart();
